export default __webpack_public_path__ + "static/media/Annuity.d42fdd62.svg";